import { useState } from 'react';
import ChatbotIcon from '../../images/chat-bot.svg';
import HistoryIcon from '../../images/history.svg';
import TextScanAiIcon from '../../images/text-scan-ai.svg';
import DashboardIcon from '../../images/dashboard.svg';
import LogoutIcon from '../../images/logout.svg';
import NotebookIcon from '../../images/notebook.svg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logoutUser } from '../../data/dataApi';
import { useUserState } from './UserStateProvider';

const Sidebar = () => {
    const location = useLocation();
    const [activePage, setActivePage] = useState(location.pathname);

    const { appVersion, userCapabilities, userLatestViewedRelease } = useUserState();

    const navigate = useNavigate();

    const menuItems = [
        {
            name: 'AI Assistant',
            link: '/home',
            icon: ChatbotIcon,
        },
        {
            name: 'History',
            link: '/history',
            icon: HistoryIcon,
        },
        {
            name: 'PDF Order Parser',
            link: '/pdf-order-parser',
            icon: TextScanAiIcon,
        },
        {
            name: 'Dashboard',
            link: '/dashboard/home',
            icon: DashboardIcon,
            target: '_blank',
            capability: 'read_dashboard'
        },
        {
            name: 'What\'s Changed',
            link: '/whats-changed',
            icon: NotebookIcon,
            new: appVersion !== userLatestViewedRelease,
        },
    ];

    const handleLogout = async () => {
        const response = await logoutUser();

        response.success && navigate("/");
    };

    return (
        <div className="sidebar tif-bg-color-white position-fixed">
            <div className="d-flex flex-column justify-content-between h-100 tif-mb-0">
                <ul className="list-unstyled d-flex flex-column tif-mb-0">
                    {
                        menuItems.filter(item => item.show === undefined || item.show === true).filter(item => item.capability ? userCapabilities.includes(item.capability) : true).map((item, index) => (
                            <OverlayTrigger key={index} overlay={<Tooltip id="ai-assistant">{item.name}</Tooltip>} placement="right">
                                <Link to={item.link} target={item.target}>
                                    <li className={`position-relative ${activePage.startsWith(item.link) ? 'active' : ''}`} onClick={!item.target ? () => setActivePage(item.link) : null}>
                                        <img src={item.icon} className="d-block" alt={item.name} />
                                        {
                                            (userLatestViewedRelease && item.new) &&
                                            <span className="new-badge position-absolute badge rounded-pill bg-danger">
                                                <span>NEW</span>
                                                <span className="visually-hidden">unread messages</span>
                                            </span>
                                        }
                                    </li>
                                </Link>
                            </OverlayTrigger>
                        ))
                    }
                </ul>
                <ul className="list-unstyled d-flex flex-column tif-mb-0">
                    <OverlayTrigger overlay={<Tooltip id="sign-out">Sign out</Tooltip>} placement="right">
                        <li onClick={handleLogout}><img src={LogoutIcon} className="d-block" alt="Logout icon" /></li>
                    </OverlayTrigger>
                </ul>
            </div>
        </div>
    );
};

export default Sidebar;